import * as React from "react";
const SvgCrossicon = props => <svg xmlns="http://www.w3.org/2000/svg" stroke="#ccc" {...props}><line x2="100%" y2="100%" /><line x1="100%" y2="100%" /></svg>;
export default SvgCrossicon;